"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18n_1 = require("../i18n");
var clientWorkOrder = /** @class */ (function () {
    function clientWorkOrder(payload, translations) {
        this.id = payload.id;
        this.clientWorkOrderStartDate = payload.clientWorkOrderStartDate;
        this.clientWorkOrderEndDate = payload.clientWorkOrderEndDate;
        this.clientWorkOrderStatusCode = payload.clientWorkOrderStatusCode;
        this.clientWorkOrderIsPlannable = payload.clientWorkOrderIsPlannable;
        if (payload.clientWorkOrderStartTimeSlot) {
            this.clientWorkOrderStartTimeSlot = this.getSlot(payload.clientWorkOrderStartTimeSlot, translations);
        }
        this.clientWorkOrderType = payload.clientWorkOrderType;
        this.clientWorkOrderStatusLabel = this.getStatus(payload.clientWorkOrderStatusCode, translations);
        this.clientWorkOrderAbortReason = this.getReason(payload.clientWorkOrderAbortReason, translations);
        this.clientWorkOrderEngagement = this.getType(payload.clientWorkOrderEngagement, translations);
        this.clientWorkOrderEngagementBool = payload.clientWorkOrderEngagement;
    }
    clientWorkOrder.prototype.getSlot = function (slot, translations) {
        if (slot === 'Matin') {
            return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.slots.morning; })(translations);
        }
        return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.slots.afternoon; })(translations);
    };
    clientWorkOrder.prototype.getType = function (type, translations) {
        if (type) {
            return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.engagement.withRdv; })(translations);
        }
        return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.engagement.withoutRdv; })(translations);
    };
    clientWorkOrder.prototype.isPassed = function (_date) {
        return new Date(_date).getTime() < new Date().getTime();
    };
    clientWorkOrder.prototype.getStatus = function (status, translations) {
        if (status === 1)
            return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.status.planed; })(translations);
        if (status === 2)
            return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.status.proceed; })(translations);
        if (status === 0)
            return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.status.toBePlaned; })(translations);
        if (status === 3)
            return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.status.done; })(translations);
        return null;
    };
    clientWorkOrder.prototype.getReason = function (reasonCode, translations) {
        switch (reasonCode) {
            case 101:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[101]; })(translations);
            case 102:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[102]; })(translations);
            case 103:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[103]; })(translations);
            case 104:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[104]; })(translations);
            case 105:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[105]; })(translations);
            case 106:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[106]; })(translations);
            case 107:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[107]; })(translations);
            case 108:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[108]; })(translations);
            case 109:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[109]; })(translations);
            case 110:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[110]; })(translations);
            case 111:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[111]; })(translations);
            case 112:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[112]; })(translations);
            case 113:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[113]; })(translations);
            case 114:
                return (0, i18n_1.getTransation)(function (t) { return t.workOrderModel.reasons[114]; })(translations);
            default:
                return '';
        }
    };
    return clientWorkOrder;
}());
exports.default = clientWorkOrder;
